import React, { useEffect, useState } from "react";
import axios from "axios";

const MyGames = () => {
  const [trackedGames, setTrackedGames] = useState([]);
  const [ratedGames, setRatedGames] = useState([]);
  const [wishlistedGames, setWishlistedGames] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));

    if (!token || !user?.id) return;

    axios.get(`/api/my-games/${user.id}`)
      .then((res) => {
        const allGames = res.data;
        setTrackedGames(allGames.filter(g => g.tracking));
        setRatedGames(allGames.filter(g => g.liked !== null));
        setWishlistedGames(allGames.filter(g => g.wishlist));
      })
      .catch((err) => {
        console.error("Failed to load your games:", err);
      });
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-6 text-white">
      <h1 className="text-3xl font-bold mb-6 text-white">My Games</h1>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">Tracked Games</h2>
        {trackedGames.length === 0 ? (
          <p className="text-gray-500">You’re not tracking any games yet.</p>
        ) : (
          <ul className="list-disc list-inside">
            {trackedGames.map((game) => (
              <li key={game.id}>{game.name}</li>
            ))}
          </ul>
        )}
      </section>

      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">Rated Games</h2>
        {ratedGames.length === 0 ? (
          <p className="text-gray-500">You haven’t rated any games yet.</p>
        ) : (
          <ul className="list-disc list-inside">
            {ratedGames.map((game) => (
              <li key={game.id}>
                {game.name} —{" "}
                <span className={game.liked === 1 ? "text-green-600" : "text-red-500"}>
                  {game.liked === 1 ? "Liked" : "Disliked"}
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">Wishlisted Games</h2>
        {wishlistedGames.length === 0 ? (
          <p className="text-gray-500">Your wishlist is empty.</p>
        ) : (
          <ul className="list-disc list-inside">
            {wishlistedGames.map((game) => (
              <li key={game.id}>{game.name}</li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};

export default MyGames;
